import {useTranslation} from "react-i18next";
import {FormControlLabel, Radio} from "@mui/material";
import {Consts} from "../../pages/consts";
import TimeIntake from "./TimeIntake";

const TimeIntakes = ({timingType, intakes, onSetIntake, onAddNewRow}) => {
  const {t: t} = useTranslation();
  const notDefinedIntakes = intakes?.filter(intake => (!isNaN(intake?.dosage) && intake?.dosage === 0)
    || intake?.intakeTime === "");

  const addNewRow = () => {
    if (intakes?.length > 0 && notDefinedIntakes?.length <= 0) {
      onAddNewRow({ intakeTime: "", dosage: 0, dosageUnit: intakes[0]?.dosageUnit });
    }
  };

  return (
    <div className="w3-row">
      <FormControlLabel
        value={ Consts.TIMES }
        control={ <Radio/> }
        label={ <label>{ t("or_specify_more_than_4_times_daily") }</label> }
        className="w3-col s4 w3-mobile"
      />
      { timingType === Consts.TIMES &&
        <div className="w3-col s7 w3-mobile w3-border w3-border-orange w3-round-large w3-padding-small">
          <div>
            { intakes?.map((intake, i) => {
              return (
                <TimeIntake
                  key={ `intake${ i }` }
                  index={ i }
                  intake={intake}
                  onSetIntake={onSetIntake}
                />
              );
            }) }
            <div className="w3-row w3-right w3-margin">
              <button
                className={
                  notDefinedIntakes?.length <= 0
                    ? "w3-btn w3-round-xlarge w3-theme-d5"
                    : "w3-btn w3-round-xlarge w3-theme-d5 w3-disabled"
                }
                onClick={ addNewRow }
              >
                + { t("add_new_row") }
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default TimeIntakes;
